import { render, staticRenderFns } from "./planes.vue?vue&type=template&id=0d4466de"
import script from "./planes.vue?vue&type=script&lang=js"
export * from "./planes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports